var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var ChartTrend = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 832", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M992 768H96a32 32 0 0 1-32-32V32a32 32 0 0 0-64 0v704a96.11 96.11 0 0 0 96 96h896a32 32 0 0 0 0-64z" }),
            React.createElement("path", { className: "cls-1", d: "M224 704h512a32 32 0 0 0 0-64H224a32 32 0 0 1-32-32V477.07a63.79 63.79 0 0 1 10.75-35.5L332.26 247.3A32 32 0 0 1 383 244l123.87 141.59A96 96 0 0 0 647 390.26l62.76-62.76a32 32 0 0 1 46.92 1.8L888.3 482.85a32.07 32.07 0 0 1 7.7 20.83V608a32 32 0 0 1-32 32h-32a32 32 0 0 0 0 64h32a96.11 96.11 0 0 0 96-96V503.68a96.08 96.08 0 0 0-23.11-62.48L805.27 287.65a96 96 0 0 0-140.77-5.41L601.75 345a32 32 0 0 1-46.75-1.56l-123.87-141.6A96 96 0 0 0 279 211.8L149.5 406.06a127.57 127.57 0 0 0-21.5 71V608a96.11 96.11 0 0 0 96 96z" }))))); };
export default ChartTrend;
//# sourceMappingURL=ChartTrend.js.map